(function () {

    /* =========================
       1. ALT ATTRIBUTE CLEANER
       ========================= */
    const imgSelector = 'img.needsclick[class*="kl-private-reset-css"]';

    function clearAlt() {
        document.querySelectorAll(imgSelector).forEach(img => {
            img.setAttribute("alt", "");

            Object.defineProperty(img, "alt", {
                set(value) {},
                get() { return ""; },
                configurable: true
            });
        });
    }

    clearAlt();


    /* =========================
       2. H1 -> H2 + CENTER ALIGN
       ========================= */
    const containerId = "rich-text-01KV9BC9CJ49GRHMM7YEFZBDW5";

    function updateHeading() {
        const container = document.getElementById(containerId);
        if (!container) return;

        const h1 = container.querySelector("h1");
        if (!h1) return;

        const h2 = document.createElement("h2");
        h2.innerHTML = h1.innerHTML;
        h2.style.cssText = h1.style.cssText;
        h2.style.textAlign = "center";

        h1.replaceWith(h2);
    }

    updateHeading();


    /* =========================
       3. COOKIE CONSENT LOGIC
       ========================= */
    const observer = new MutationObserver(() => {

        /* ---- alt cleanup ---- */
        clearAlt();

        /* ---- heading update ---- */
        updateHeading();

        /* ---- cookie consent ---- */
        const consentHost = document.querySelector('csm-cookie-consent');
        if (!consentHost || !consentHost.shadowRoot) return;

        const root = consentHost.shadowRoot;

        if (window.innerWidth > 1024) {
            const btn = root.querySelector('.isense-cc-submit-consent');

            if (btn && !btn.dataset.focusBound) {
                btn.dataset.focusBound = 'true';

                btn.addEventListener('click', function () {
                    setTimeout(() => {
                        const emailInput = document.querySelector(
                            '#email_01KP3YVJ0GAH7CJXPNMPN7ADDP'
                        );
                        if (emailInput) emailInput.focus();
                    }, 500);
                });
            }

            return;
        }

        function updateMobileInertState() {

            root.querySelectorAll('.csm-native-cookie-details-collapse')
                .forEach(section => {

                    const trigger = root.querySelector(
                        `[aria-controls="${section.id}"]`
                    );

                    const isExpanded =
                        trigger &&
                        trigger.getAttribute('aria-expanded') === 'true';

                    if (isExpanded) {
                        section.removeAttribute('inert');
                        section.removeAttribute('aria-hidden');
                    } else {
                        section.setAttribute('inert', '');
                        section.setAttribute('aria-hidden', 'true');
                    }
                });

            root.querySelectorAll('.csm-native-preferences-container > div')
                .forEach(container => {

                    const height = container.style.height;

                    if (
                        height === '0px' ||
                        getComputedStyle(container).height === '0px'
                    ) {
                        container.setAttribute('inert', '');
                        container.setAttribute('aria-hidden', 'true');
                    } else {
                        container.removeAttribute('inert');
                        container.removeAttribute('aria-hidden');
                    }
                });
        }

        updateMobileInertState();

        root.querySelectorAll('[aria-controls]').forEach(trigger => {

            if (trigger.dataset.inertBound) return;

            trigger.dataset.inertBound = 'true';

            trigger.addEventListener('click', () => {
                setTimeout(updateMobileInertState, 50);
                setTimeout(updateMobileInertState, 350);
            });
        });

        root.querySelectorAll('.csm-native-preferences-container > div')
            .forEach(container => {

                if (container.dataset.heightObserverBound) return;

                container.dataset.heightObserverBound = 'true';

                const heightObserver = new MutationObserver(() => {
                    updateMobileInertState();
                });

                heightObserver.observe(container, {
                    attributes: true,
                    attributeFilter: ['style']
                });
            });
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });

})();

// (function () {

//     /* =========================================================
//        Fix: iOS VoiceOver + aria-owns combobox listbox

//        Root cause of both reported bugs:
//        - The listbox (#downshift-66-menu) is associated to the
//          input only via aria-owns, not real DOM nesting/tabindex
//          focusability. iOS VoiceOver (WebKit) frequently fails to
//          include aria-owns-only elements in swipe navigation, and
//          does not reliably announce aria-activedescendant changes.

//        Fix:
//        1. Give every role="option" a tabindex="-1" so it becomes a
//           focusable node in the accessibility tree, which is what
//           actually gets it included in VoiceOver's swipe order.
//        2. Explicitly announce the current selection through a
//           visually-hidden aria-live region, instead of relying on
//           aria-activedescendant alone.
//        ========================================================= */

//     let liveRegion;

//     function ensureLiveRegion() {
//         if (liveRegion && document.body.contains(liveRegion)) return liveRegion;

//         liveRegion = document.createElement('div');
//         liveRegion.setAttribute('aria-live', 'polite');
//         liveRegion.setAttribute('role', 'status');
//         liveRegion.style.cssText =
//             'position:absolute;width:1px;height:1px;margin:-1px;' +
//             'padding:0;overflow:hidden;clip:rect(0,0,0,0);' +
//             'white-space:nowrap;border:0;';

//         document.body.appendChild(liveRegion);
//         return liveRegion;
//     }

//     /* -----------------------------------------------------------
//        Fix: double-tap not activating an option.

//        Downshift-style comboboxes typically select an item on
//        "mousedown" rather than "click" (this lets selection fire
//        before the input's blur/close-list logic runs). iOS
//        VoiceOver's double-tap gesture on a non-native element
//        (div[role="option"]) dispatches only a "click" event —
//        no preceding mousedown/mouseup — so that mousedown-based
//        selection handler never runs and the tap appears to do
//        nothing.

//        Fix: intercept the click in the capture phase (before it
//        reaches the widget's own bubble-phase click handler) and
//        replay a full mousedown -> mouseup pair on the same
//        element first, so whichever event type the underlying
//        widget actually listens for gets fired.
//     ----------------------------------------------------------- */
//     function bindActivation(option) {
//         if (option.dataset.activationBound) return;
//         option.dataset.activationBound = 'true';

//         option.addEventListener('click', function () {
//             ['mousedown', 'mouseup'].forEach(type => {
//                 option.dispatchEvent(new MouseEvent(type, {
//                     bubbles: true,
//                     cancelable: true,
//                     view: window
//                 }));
//             });
//         }, true);
//     }

//     /* -----------------------------------------------------------
//        Fix: focus jumping back to the first list item after
//        VoiceOver finishes reading the list.

//        enhanceCountryDropdown() was calling setAttribute() on
//        every option/input on every run, even when the value
//        hadn't changed. setAttribute() always emits a mutation
//        record regardless of whether the value actually changed,
//        and our own MutationObserver watches
//        attributeFilter: ['aria-selected', 'style', 'class'] on
//        document.body — so every run re-triggered the observer,
//        which re-ran enhanceCountryDropdown(), which set the
//        attributes again, forever. That constant attribute churn
//        on the subtree VoiceOver was actively reading is what
//        invalidated its cursor and snapped focus back to the
//        first item instead of letting it continue forward past
//        the list.

//        Fix: only write an attribute/property when the value has
//        actually changed, so mutation records only fire on real,
//        external changes.
//     ----------------------------------------------------------- */
//     function setAttrIfChanged(el, attr, value) {
//         if (el.getAttribute(attr) !== value) {
//             el.setAttribute(attr, value);
//         }
//     }

//     function setValueIfChanged(el, value) {
//         if (el.value !== value) {
//             el.value = value;
//         }
//     }

//     /* -----------------------------------------------------------
//        Fix: newly/dynamically added options never reachable by
//        VoiceOver, even with tabindex="-1" already applied.

//        WebKit computes the aria-owns relationship between the
//        input and #downshift-66-menu once, when it first builds
//        its accessibility tree for that subtree. It does not
//        reliably re-scan the owned element's children when options
//        are added/removed later (e.g. as the user types and the
//        list re-filters). tabindex="-1" alone only matters if the
//        option is part of an accessibility subtree WebKit has
//        actually scanned — for options that arrived after that
//        initial scan, VoiceOver still doesn't know they exist.

//        Fix: whenever the actual set of option ids changes, briefly
//        remove and re-add aria-owns on the input. That forces
//        WebKit to throw away and rebuild the owned subtree's
//        accessibility nodes, which is what makes newly-inserted
//        options show up in swipe navigation.
//     ----------------------------------------------------------- */
//     let lastOptionIds = '';

//     function refreshAriaOwnsIfOptionsChanged(input, listbox) {
//         const currentIds = Array.from(listbox.querySelectorAll('[role="option"]'))
//             .map(o => o.id)
//             .join('|');

//         if (currentIds === lastOptionIds) return;
//         lastOptionIds = currentIds;

//         const ownsId = input.getAttribute('aria-owns');
//         if (!ownsId) return;

//         input.removeAttribute('aria-owns');
//         // Force layout/AX flush before re-adding, otherwise the
//         // remove+add can get coalesced into a no-op by the browser.
//         void input.offsetHeight;
//         requestAnimationFrame(() => {
//             input.setAttribute('aria-owns', ownsId);
//         });
//     }

//     let lastAnnounced = '';

//     function announceSelection(countryName) {
//         if (!countryName || countryName === lastAnnounced) return;
//         lastAnnounced = countryName;

//         const region = ensureLiveRegion();
//         // Clear first so VoiceOver treats the next update as a change,
//         // even if the text happens to match something announced earlier.
//         region.textContent = '';
//         setTimeout(() => {
//             region.textContent = 'Selected country: ' + countryName;
//         }, 100);
//     }

//     function enhanceCountryDropdown() {

//         const input = document.querySelector('#downshift-66-input');
//         const listbox = document.querySelector('#downshift-66-menu');

//         if (!input || !listbox) return;

//         /* -----------------------------
//            Remove flag images from SR
//         ----------------------------- */
//         listbox.querySelectorAll('img').forEach(img => {
//             img.setAttribute('alt', '');
//             img.setAttribute('aria-hidden', 'true');
//             img.removeAttribute('aria-label');
//             img.removeAttribute('title');
//             img.setAttribute('role', 'presentation');
//         });

//         /* -----------------------------
//            Make options reachable by VoiceOver.
//            tabindex="-1" pulls each option into the
//            accessibility tree as a focusable node, which
//            is required for iOS VoiceOver swipe navigation
//            to reach aria-owns'd listbox items.
//         ----------------------------- */
//         listbox.querySelectorAll('[role="option"]').forEach(option => {
//             if (!option.hasAttribute('tabindex')) {
//                 option.setAttribute('tabindex', '-1');
//             }
//             bindActivation(option);
//         });

//         refreshAriaOwnsIfOptionsChanged(input, listbox);

//         /* -----------------------------
//            Find selected option
//         ----------------------------- */
//         const selected = listbox.querySelector('[role="option"][aria-selected="true"]');

//         if (selected) {

//             // Sync active descendant
//             setAttrIfChanged(input, 'aria-activedescendant', selected.id);

//             // Update accessible name
//             const country =
//                 selected.querySelector('span')?.textContent.trim() ||
//                 selected.getAttribute('aria-label') ||
//                 '';

//             if (country) {
//                 setAttrIfChanged(input, 'aria-label', 'Country, ' + country);
//                 setValueIfChanged(input, country);

//                 // iOS VoiceOver does not reliably announce
//                 // aria-activedescendant changes on its own, so
//                 // explicitly announce the current selection.
//                 announceSelection(country);
//             }
//         }

//         /* -----------------------------
//            Keep only one selected option
//         ----------------------------- */
//         listbox.querySelectorAll('[role="option"]').forEach(option => {

//             const active =
//                 option.id === input.getAttribute('aria-activedescendant');

//             setAttrIfChanged(
//                 option,
//                 'aria-selected',
//                 active ? 'true' : 'false'
//             );
//         });
//     }

//     /* ---------------------------------
//        Observe DOM changes
//     ---------------------------------- */
//     const observer = new MutationObserver(() => {

//         enhanceCountryDropdown();

//     });

//     observer.observe(document.body, {
//         childList: true,
//         subtree: true,
//         attributes: true,
//         attributeFilter: ['aria-selected', 'style', 'class']
//     });

//     enhanceCountryDropdown();

// })();

 (function () {
  "use strict";

  const COMBOBOX_SELECTOR = 'input[role="combobox"]';

  function getCountryName(option) {
    if (!option) return "";

    const span = option.querySelector("span");
    if (span) return span.textContent.trim();

    const img = option.querySelector("img");
    if (img?.ariaLabel) return img.ariaLabel.trim();

    return option.textContent.trim();
  }

  function enhanceCombobox(input) {
    if (input.dataset.a11yEnhanced) return;
    input.dataset.a11yEnhanced = "true";

    function updateList() {
      const listboxId =
        input.getAttribute("aria-controls") ||
        input.getAttribute("aria-owns");

      if (!listboxId) return;

      const listbox = document.getElementById(listboxId);
      if (!listbox) return;

      const options = [...listbox.querySelectorAll('[role="option"]')];

      if (!options.length) return;

      options.forEach((option, index) => {

        if (!option.id) {
          option.id = `${listboxId}-option-${index}`;
        }

        option.setAttribute("tabindex", "-1");

        const label = getCountryName(option);

        option.setAttribute("aria-label", label);

        option.addEventListener("mouseenter", () => {
          input.setAttribute("aria-activedescendant", option.id);

          options.forEach(o => o.setAttribute("aria-selected", "false"));
          option.setAttribute("aria-selected", "true");
        });

        option.addEventListener("click", () => {
          const selected = getCountryName(option);

          input.value = selected;
          input.setAttribute("aria-label", selected);
          input.setAttribute("aria-activedescendant", option.id);

          options.forEach(o => o.setAttribute("aria-selected", "false"));
          option.setAttribute("aria-selected", "true");
        });

      });

      let activeIndex = options.findIndex(
        o => o.id === input.getAttribute("aria-activedescendant")
      );

      if (activeIndex < 0) activeIndex = 0;

      input.onkeydown = function (e) {

        if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

        if (e.key === "ArrowDown") {
          activeIndex = Math.min(activeIndex + 1, options.length - 1);
        }

        if (e.key === "ArrowUp") {
          activeIndex = Math.max(activeIndex - 1, 0);
        }

        const option = options[activeIndex];

        input.setAttribute("aria-activedescendant", option.id);

        options.forEach(o => o.setAttribute("aria-selected", "false"));
        option.setAttribute("aria-selected", "true");

        option.scrollIntoView({
          block: "nearest"
        });

        if (e.key === "Enter") {

          const selected = getCountryName(option);

          input.value = selected;
          input.setAttribute("aria-label", selected);

          input.dispatchEvent(new Event("change", {
            bubbles: true
          }));

          input.dispatchEvent(new Event("input", {
            bubbles: true
          }));
        }

      };


      if (input.value) {

        const current = options.find(o =>
          getCountryName(o).toLowerCase() ===
          input.value.trim().toLowerCase()
        );

        if (current) {
          input.setAttribute("aria-activedescendant", current.id);

          options.forEach(o => o.setAttribute("aria-selected", "false"));
          current.setAttribute("aria-selected", "true");

          input.setAttribute("aria-label", getCountryName(current));
        }
      }
    }

    const observer = new MutationObserver(updateList);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    updateList();
  }

  function scan() {
    document.querySelectorAll(COMBOBOX_SELECTOR).forEach(enhanceCombobox);
  }

  const pageObserver = new MutationObserver(scan);

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  scan();

})();

(function () {
  function init() {
    const input = document.querySelector('input[role="combobox"]');
    const listbox = document.querySelector('[role="listbox"]');

    if (!input || !listbox) return false;

    function syncAccessibility() {
      const options = [...listbox.querySelectorAll('[role="option"]')];
      if (!options.length) return;

      let activeOption = null;

      // Prefer the option already selected by Downshift
      activeOption = options.find(
        (opt) => opt.getAttribute("aria-selected") === "true"
      );

      // Otherwise match the current input value
      if (!activeOption && input.value.trim()) {
        activeOption = options.find((opt) => {
          const label =
            opt.getAttribute("aria-label") ||
            opt.textContent.trim();

          return (
            label.toLowerCase() === input.value.trim().toLowerCase()
          );
        });
      }

      // Last fallback: existing aria-activedescendant
      if (!activeOption) {
        const currentId = input.getAttribute("aria-activedescendant");
        if (currentId) {
          activeOption = document.getElementById(currentId);
        }
      }

      if (!activeOption) return;

      // ONLY update aria-activedescendant
      if (input.getAttribute("aria-activedescendant") !== activeOption.id) {
        input.setAttribute(
          "aria-activedescendant",
          activeOption.id
        );
      }
    }

    syncAccessibility();

    const observer = new MutationObserver(() => {
      requestAnimationFrame(syncAccessibility);
    });

    observer.observe(listbox, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        "aria-selected",
        "class",
        "aria-label"
      ]
    });

    input.addEventListener("input", () => {
      requestAnimationFrame(syncAccessibility);
    });

    input.addEventListener("keydown", () => {
      requestAnimationFrame(syncAccessibility);
    });

    input.addEventListener("click", () => {
      requestAnimationFrame(syncAccessibility);
    });

    return true;
  }

  const timer = setInterval(() => {
    if (init()) {
      clearInterval(timer);
    }
  }, 100);
})();

(function () {
  function init() {
    const input = document.querySelector('input[role="combobox"]');
    const listbox = document.querySelector('[role="listbox"]');

    if (!input || !listbox) return false;

    function updateActiveDescendant() {
      const selected = listbox.querySelector(
        '[role="option"][aria-selected="true"]'
      );

      if (selected && input.getAttribute("aria-activedescendant") !== selected.id) {
        input.setAttribute("aria-activedescendant", selected.id);
      }
    }

    updateActiveDescendant();

    new MutationObserver(updateActiveDescendant).observe(listbox, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["aria-selected"]
    });

    return true;
  }

  const timer = setInterval(() => {
    if (init()) clearInterval(timer);
  }, 100);
})();

(function () {
  document.addEventListener(
    "click",
    function (e) {
      const option = e.target.closest('[role="option"]');
      if (!option) return;

      const input = document.querySelector('input[role="combobox"]');
      if (!input) return;

      // Already selected? Nothing to do.
      if (option.getAttribute("aria-selected") === "true") {
        const label =
          option.getAttribute("aria-label") ||
          option.textContent.trim();

        // Update the visible input
        input.value = label;

        input.setAttribute("aria-label", label);
        input.setAttribute("aria-activedescendant", option.id);

        // Notify React/Downshift
        input.dispatchEvent(
          new InputEvent("input", {
            bubbles: true,
            composed: true
          })
        );

        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
            composed: true
          })
        );

        input.dispatchEvent(
          new Event("blur", {
            bubbles: true
          })
        );
      }
    },
    true
  );
})();